import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const QrScannerAndroid: React.FC = () => (
  <SEOLandingPage
    title="QR Code Scanner & Generator for Android — Free, No Ads on Scan | Cosmovex"
    metaDescription="Free QR code scanner and generator for Android. Scan QR codes and barcodes instantly with your camera, create your own QR codes for links, Wi-Fi, contacts and text, and keep a scan history — no account needed."
    ogTitle="QR Code Scanner & Generator for Android — Scan & Create QR Codes Free"
    h1="QR Code Scanner & Generator for Android"
    intro="Point, scan, done. QR Scanner & Generator reads QR codes and barcodes instantly with your camera — and creates clean QR codes for links, Wi-Fi networks, contacts, and plain text. Free, with a full scan history and no account."
    paragraphs={[
      "Scanning should be instant. Open the app and the camera is already looking for codes — QR codes, web links, Wi-Fi credentials, contact cards, phone numbers, SMS, email addresses, and standard product barcodes. The result appears the moment the code is in frame, with a clear action button for whatever the code contains: open the link, join the Wi-Fi, save the contact, or copy the text.",
      "Creating QR codes is just as quick. Turn any website link, Wi-Fi network, contact card, phone number, or block of text into a crisp QR code in seconds, then share it anywhere or save it to your gallery. Perfect for sharing your guest Wi-Fi at home, putting a menu link on a table card, or moving a long URL from your laptop to a friend's phone without typing.",
      "Everything you scan and create is kept in a tidy history, so a code you scanned last week is one tap away — no re-scanning, no digging through screenshots. Items can be favorited, searched, copied, shared, or deleted. If a code contained a link, you can reopen it any time.",
      "Privacy stays simple: scanning happens on your device with your camera, and no account or sign-up is ever asked for. The app is free to download, light on storage, and built with a clean dark interface that makes both scanning and generating feel effortless.",
    ]}
    features={[
      "Instant camera scanning for QR codes and barcodes",
      "Smart actions — open links, join Wi-Fi, save contacts, copy text",
      "Generate QR codes for links, Wi-Fi, contacts, phone, SMS & text",
      "Share generated codes anywhere or save them to your gallery",
      "Full scan & creation history with search and favorites",
      "Flashlight toggle for low-light scanning",
      "Scan from images already in your gallery",
      "No account, no sign-up — free to download",
    ]}
    related={[
      { label: "QR Code Generator for Android", path: "/qr-code-generator-android", tagline: "Make QR codes free" },
      { label: "Barcode Scanner for Android", path: "/barcode-scanner-android", tagline: "Read product barcodes" },
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.qrpilot"
    icon="/images/play/qrpilot.png"
    appName="QR Scanner & Generator"
    accentColor="#A8720E"
    canonicalPath="/qr-scanner-android"
  />
);

export default QrScannerAndroid;
